// extracted by mini-css-extract-plugin
export default {"footerLogos":"Logos-module__footerLogos__2URgs","footerLogo":"Logos-module__footerLogo__6s3Oj"};